export const AutoReplenishDropdownTheme = `
    .elc-dropdown-wrapper {
        border: 0;
    }

    .elc-dropdown-arrow {
        border: 0;
    }

    .elc-dropdown-options {
        border: 0;
    }
`;
